import { DropdownController } from "./dropdown-controller.interface";
import { DropdownComponent } from "../dropdown.component";

export class DefaultDropdownController implements DropdownController {
    component: DropdownComponent;

    change(): void {

    }

    onInit(): void {

    }
}